require('./modifyChoreFinalStep.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');

// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ components
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const WizardError = require('components/commons/wizardError/wizardError');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');

// @ constants
const { DATE_FORMAT_API, DATE_FORMAT_DAY_MONTH_YEAR } = require('constants/index');

//@ utilities
const { getCurrencySymbol, getFormattedString } = require('utilities/currencyHelper');

class ModifyChoreFinalStep extends React.Component {
    constructor(props) {
        super(props);

        this.buildSuccess = this.buildSuccess.bind(this);
        this.buildError = this.buildError.bind(this);
        this.modifyList = this.modifyList.bind(this);
    }

    modifyList(list){
        const modifiedListLength = list.filter(data => data.key);

        let listClassName = modifiedListLength.length > 2 ? '6' : '12';

        const modifiedList = list.map((data, index) => {
            if(data.key){
                return(
                    <OKInformativeListItem
                        bodyText={data.key}
                        bodyWordBreak={false}
                        key={index}
                        title={data.title}
                        className={`modify-chore-final-step__list-item col-xs-${listClassName}`}
                    />
                )
            }
        });
        return modifiedList;
    }

    buildError() {
        const { immCard } = this.props;
        const cardId = immCard.get('cardId');
        const errorTitle = formatText('modifyChoreFinalStep-errorTitle');
        const goBackButtonLabel = formatText('modifyChoreFinalStep-backToCard').toUpperCase();
        const linkToDetails = `/myprofile/cards/${cardId}/movements`;
        const mainButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        };

        return (
            <WizardError
                errorMessage={errorTitle}
                mainButton={mainButton}
            >
                <section className="modify-money-final-step__content row">
                    <div className="col-xs-5 col-md-5">
                        <CommercialAds path="cards" type="cards" immCard={immCard} size="large" />
                    </div>
                    <div className="col-xs-7 col-md-7">
                        <p className="modify-money-final-step__error-message">
                            <FormattedText value="modifyChoreFinalStep-errorMessage" />
                        </p>
                    </div>
                </section>
            </WizardError>
        );
    }

    buildSuccess() {
        const { immOpenYoungCardModifyChore, immCard, immChoreDetails } = this.props;
        const cardId = immCard.get('cardId');
        let isAmountSame = immOpenYoungCardModifyChore.get('amount') === immChoreDetails.get('reward');
        const currency =  getCurrencySymbol(immCard.get('availableBalance'));
        const amountValue = isAmountSame ? '' : immOpenYoungCardModifyChore.get('amount');
        const amount =  isAmountSame ? '' : [
            getFormattedString({ amount: amountValue, currency })
        ];
        let validEndDate = moment(immOpenYoungCardModifyChore.get('selectedEndDate').format(DATE_FORMAT_API)).isSame(moment(immChoreDetails.get('endDate')));
        const selectedEndDate = validEndDate ? '' : immOpenYoungCardModifyChore.get('selectedEndDate').format(DATE_FORMAT_DAY_MONTH_YEAR);
        const modifiedConcept = immOpenYoungCardModifyChore.get('concept');
        const concept = modifiedConcept === immChoreDetails.getIn(['comments','choreAssignmentComment']) ? '' : (modifiedConcept && modifiedConcept.trim() || '-');
        const goBackButtonLabel = formatText('modifyChoreFinalStep-backToCard').toUpperCase();
        const linkToDetails = `/myprofile/cards/${cardId}/movements`;
        const successMessage = formatText('modifyChoreFinalStep-successTitle');
        const goBackButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        };

        const list = [
            {
                key: amount,
                title: formatText('modifyChoreStep-amount')
            },
            {
                key: concept,
                title: formatText('modifyChoreStep-concept')
            },
            {
                key: selectedEndDate,
                title: formatText('modifyChoreStep-selectedEndDate')
            }
        ];

        return (
            <WizardSuccess
                successMessage={successMessage}
                mainButton={goBackButton}>
                <section className="modify-chore-final-step__content row">
                    <div className="col-xs-4 col-md-5">
                        <CommercialAds path="cards" type="cards" immCard={immCard} size="large" />
                    </div>
                    <FormattedText className="modify-chore-final-step__success-message" value="modifyChoreFinalStep-successMessage" />
                    <OKInformativeList columns={2}>
                        {this.modifyList(list)}
                    </OKInformativeList>
                </section>
            </WizardSuccess>
        );
    }

    render() {
        const finalBlock = this.props.errorState ? this.buildError() : this.buildSuccess();

        return (
            <article className="modify-chore-final-step">
                {finalBlock}
            </article>
        )
    }
}

ModifyChoreFinalStep.propTypes = {
    errorState: PropTypes.bool.isRequired,
    immOpenYoungCardModifyChore: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired,
    immChoreDetails: PropTypes.object.isRequired
};

module.exports = ModifyChoreFinalStep;
